interface GetGapChannelIncludeChannelCellValueInput {
    editsString: string;
    gapChannel: TrqkGapChannel;
}

export const getGapChannelIncludeChannelCellValue = ({
    editsString,
    gapChannel,
}: GetGapChannelIncludeChannelCellValueInput): GapChannelIncludeCellValue => {
    const { channel_id: channelId } = gapChannel;
    const audiosIncluded = gapChannel?.audios_included ?? 0;
    const hasIncludedAudios = audiosIncluded > 0;

    const emptyCellValue = {
        channelId,
        checked: false,
        hasIncludedAudios,
    };

    let edits: Record<string, GapAnalysisEdits> = {};

    try {
        edits = JSON.parse(editsString);
    } catch {
        return emptyCellValue;
    }

    const checked = edits?.[channelId]?.checked ?? false;

    return {
        channelId,
        hasIncludedAudios,
        checked,
    };
};
